/* globals App */

import axios from "axios";

export class Security {
  initTotp(container, onSuccess) {
    let submit = container.querySelector("button[type=submit]");
    submit.classList.add("btn-primary", "ms-3");
    container.querySelectorAll("h2").forEach((el, index) => {
      el.classList.add(index == 0 ? "mb-3" : "my-3");
    });
    let copy = container.querySelector(".copytext");
    if (copy) {
      copy.classList.add("flex");
      let button = copy.querySelector("button");
      button.classList.add("js-copy", "ms-3", "btn-secondary");
      button.dataset.copy = copy.querySelector(".code").value;
      button.innerHTML = "Copy";
      App.initCopy(container);
    }
    container.querySelector(".heading").classList.add("font-semibold", "mb-2");
    container.querySelectorAll("[data-attribute], .field").forEach((el) => {
      el.classList.add("form-field", "my-3");
    });
    let form = container.querySelector("form");
    let field = container.querySelector("#verification-code-field");
    let code = form.querySelector("input.code");
    this.initCodeField(code);
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      const data = new FormData();
      data.append("code", code.value);
      data.append("action", "auth/verify-totp");
      if (data.get("code").trim().length != 6) {
        field.classList.add("has-error");
        return;
      }
      this.submitForm(submit, data, onSuccess);
    });
  }

  initEmailOtp(container, onSuccess) {
    let field = container.querySelector(".field");
    let form = container.querySelector("form");
    let submit = container.querySelector("button[type=submit]");
    submit.classList.add("btn-primary", "me-3");
    container.querySelector(".heading").classList.add("font-semibold", "mb-2");
    field.classList.add("form-field", "my-3");
    let resend = container.querySelector("button.resend");
    let uid = container.querySelector("input.uid");
    let otp = container.querySelector("input.otp");
    this.initCodeField(otp);
    resend.addEventListener("click", (event) => {
      event.preventDefault();
      const data = new FormData();
      data.append("action", "site/auth/resend-email-otp");
      data.append("uid", uid.value);
      this.submitForm(resend, data, null, "spinner-dark");
    });
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      const data = new FormData();
      data.append("uid", uid.value);
      data.append("otp", otp.value);
      data.append("action", "site/auth/verify-email-otp");
      if (otp.value.trim().length != 6) {
        field.classList.add("has-error");
        return;
      }
      this.submitForm(submit, data, onSuccess);
    });
  }

  initRecoveryCodes(container, onSuccess) {
    let field = container.querySelector(".field");
    let form = container.querySelector("form");
    let submit = container.querySelector("button[type=submit]");
    submit.classList.add("btn-primary", "ms-3");
    container.querySelector(".heading").classList.add("font-semibold", "mb-2");
    field.classList.add("form-field", "my-3");
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      const data = new FormData();
      data.append("code", form.querySelector("input.code").value);
      data.append("action", "auth/verify-recovery-code");
      if (data.get("code").trim().length == 0) {
        field.classList.add("has-error");
        return;
      }
      this.submitForm(submit, data, onSuccess);
    });
  }

  initSetupRecoveryCodes(container) {
    let button = container.querySelector("button[type=submit]");
    button.type = "button";
    button.classList.add("btn-primary", "mt-3");
    button.addEventListener("click", (event) => {
      event.preventDefault();
      const data = new FormData();
      data.append(App.settings.csrfTokenName, App.settings.csrfToken);
      data.append("action", "auth/generate-recovery-codes");
      this.submitForm(button, data, (data) => {
        data = data.data;
        let pre = document.createElement("pre");
        pre.classList.add("mt-3");
        pre.innerHTML = data.codes.join("\n");
        container.appendChild(pre);
        button.classList.add("hidden");
        let download = document.createElement("button");
        download.type = "button";
        download.innerHTML = "Download Codes";
        download.classList.add("mt-3", "btn", "btn-primary");
        container.appendChild(download);
        this.initDownloadButton(download);
      });
    });
  }

  initDownloadButton(button) {
    button.addEventListener("click", (event) => {
      const data = new FormData();
      data.append("action", "auth/download-recovery-codes");
      this.submitForm(button, data, (data) => {
        const element = document.createElement("a");
        element.style.display = "none";
        element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(data.data));
        element.setAttribute("download", "forwardvia-recovery-codes.txt");
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      });
    });
  }

  initCodeField(code) {
    code.addEventListener("input", (event) => {
      if (code.value.trim().length == 6) {
        code.closest("form").dispatchEvent(new CustomEvent("submit", { cancelable: true }));
      }
    });
  }

  showError(error) {
    let errorData = error.response ? error.response.data : {};
    let message = errorData.message || "An error occurred";
    App.toasts.create({
      message: message,
      type: "error",
    });
  }

  submitForm(submit, formData, onSuccess, spinnerClass) {
    submit.classList.add("has-spinner");
    if (spinnerClass) {
      submit.classList.add(spinnerClass);
    }
    submit.disabled = true;
    formData.append(App.settings.csrfTokenName, App.settings.csrfToken);
    return axios
      .post("/", formData)
      .then((data) => {
        if (data.data.message) {
          App.toasts.create({
            message: data.data.message,
            type: "success",
          });
        }
        if (onSuccess) {
          onSuccess(data);
        }
      })
      .catch((error) => {
        this.showError(error);
      })
      .finally(() => {
        submit.classList.remove("has-spinner");
        submit.disabled = false;
      });
  }
}
